import { createSlice } from "@reduxjs/toolkit";
import { getInstalledExtensions } from "../Action/extensions.action";

const extensionSlice = createSlice({
  name: "extensions",
  initialState: {
    extensionData: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInstalledExtensions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInstalledExtensions.fulfilled, (state, action) => {
        state.loading = false;
        state.extensionData = action.payload;
      })
      .addCase(getInstalledExtensions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.extensionData = [];
      });
  },
});

export default extensionSlice.reducer;
